// extracted by mini-css-extract-plugin
export default {"BadgeDot":"BadgeDot_BadgeDot__0eBdN","BadgeDotSmall":"BadgeDot_BadgeDotSmall__Ma-bA","Active":"BadgeDot_Active__d3SSs"};